/**
 * Shortlist Add To
 */

export function shortlistAddTo() {
  const c = {
    dom: {
      addToShortlistBtn: 'js-product-heart',
      collection: 'collection',
      compareBtn: 'js-compare-btn',
      comparePanel: 'js-compare-panel-acc',
      comparePanelTab: 'js-acc-btn',
      comparePanelToggle: 'js-compare-panel-toggle',
      productItem: 'js-pi',
      productItemApp: 'js-product-item-app',
      shortlistItem: 'js-shortlist-item',
      shortlistItemsList: 'js-shortlist-items',
      shortlistItemDetails: 'js-shortlist-item-details',
      shortlistItemImage: 'js-shortlist-item-image',
      shortlistItemMedia: 'js-shortlist-item-media',
      shortlistItemPrice: 'js-shortlist-item-price',
      shortlistItemTitle: 'js-shortlist-item-title',
      shortlistRemaining: 'js-shortlist-remaining',
      panel: 'shortList',
    },
    cls: {
      active: 'is-active',
      added: 'added',
      empty: 'empty',
      hide: 'hide',
      inactive: 'inactive',
      isSelected: 'is-selected',
    },
  };

  // Globals
  const $comparePanel = document.getElementById(c.dom.comparePanel);
  const $comparePanelTab = document.getElementById(c.dom.comparePanelTab);
  const $comparePanelToggle = document.querySelector(`.${c.dom.comparePanelToggle}`);
  const $addToShortlistBtns = document.querySelectorAll(`.${c.dom.addToShortlistBtn}`);
  const $allShortlistItems = document.querySelectorAll(`.${c.dom.shortlistItem}`);
  const $panel = document.getElementById(c.dom.panel);
  const $collection = document.getElementById(c.dom.collection);

  // Data
  const sessionStorage = window.sessionStorage || null;

  /**
   * Init
   */
  function init() {
    if (!$addToShortlistBtns?.length > 0) return;

    addEvents();
  }

  /**
   * Add Events
   */
  function addEvents() {
    $addToShortlistBtns.forEach(($btn) => {
      $btn.setAttribute('data-short-list-trigger', true);

      __.addEvent({
        id: c.dom.collection,
        className: c.dom.addToShortlistBtn,
        event: 'click',
        fn: handleAddToShortlistClick,
      });
    });

    $allShortlistItems.forEach(() => {
      __.addEvent({
        id: c.dom.collection,
        className: c.dom.shortlistItem,
        event: 'click',
        fn: handleRemoveFromShortlistClick,
      });
    });

    __.addEvent({
      id: c.dom.comparePanelTab,
      className: c.dom.comparePanelToggle,
      event: 'click',
      fn: handleTabToggle,
    });

    __.addEvent({
      id: c.dom.comparePanel,
      className: c.dom.compareBtn,
      event: 'click',
      fn: handleNavigation,
    });

    // watches for more items added to the DOM
    if ($collection) {
      const observer = new MutationObserver(detectItemsAdded);
      observer.observe($collection, { subtree: true, childList: true });
    }
  }

  /**
   * Detect Items Added - watches for product items added to the DOM
   */
  function detectItemsAdded(entries) {
    entries.forEach((mutation) => {
      mutation?.addedNodes?.forEach((added) => {
        if (added) {
          const $items = document.querySelectorAll(`.${c.dom.addToShortlistBtn}`);
          if (!$items?.length > 0) return;

          [...$items].forEach(($item) => {
            const hasEvent = $item.getAttribute('data-short-list-trigger');
            // if item has event skip item
            if (hasEvent) return;

            $item.setAttribute('data-short-list-trigger', true);
            __.addEvent({
              id: c.dom.collection,
              className: c.dom.addToShortlistBtn,
              event: 'click',
              fn: handleAddToShortlistClick,
            });
          });
        }
      });
    });
  }

  /**
   * Check for duplicate and remove
   * @param {String} newItemId
   * @description Checks for duplicate item in shortlist and removes it
   * @returns {Boolean}
   */
  function checkForDuplicateAndRemove(newItemId) {
    if (!$panel) return false;

    const $addedItems = $panel.querySelectorAll(`.${c.dom.shortlistItem}`);

    const isAdded = [...$addedItems].find(($item) => {
      const { productId } = $item.dataset || null;
      if (productId === newItemId) {
        return $item;
      }

      return false;
    });

    if (isAdded) {
      handleRemoveFromShortlistClick(isAdded);

      return true;
    }

    return false;
  }

  /**
   * Handle Add To Shortlist Click
   * @param {Object} e - click event
   */
  function handleAddToShortlistClick(e) {
    const currentItems = JSON.parse(sessionStorage.getItem('comparePanelStorage')) || [];
    const location = window.location.href;
    const id = Math.floor(Math.random() * Date.now());
    const $shortlistItems = document.querySelectorAll(`.${c.dom.shortlistItem}`);
    const target = e.target || e;
    const $shortListBtn = __.parents(target, `.${c.dom.addToShortlistBtn}`)[0];
    const $shortListBtnParents = __.parents($shortListBtn);
    const $productItemApp = $shortListBtnParents
      ? $shortListBtnParents.find(($parent) => $parent.classList.contains(c.dom.productItemApp))
      : null;
    const $productItem = $shortListBtnParents
      ? $shortListBtnParents.find(($parent) => $parent.classList.contains(c.dom.productItem))
      : null;
    const $productItemData = $productItem
      ? $productItem.querySelector('script').innerHTML
      : null;

    /* eslint-disable-next-line */
    const $emptyShortlistItem = Array.from($shortlistItems).find(($item) => $item.classList.contains(c.cls.empty));

    const {
      productId,
      handle,
      imageAlt,
      imageSrc,
      productBadge,
      productDimensions,
      productCardVariantImages,
      productSubtitle,
      productTitle,
      comparePanelAssetSrc,
      comparePanelAssetAlt,
      comparePanelPrice,
    } = $productItemApp.dataset;

    const comparePanelStorage = {
      id,
      location,
      productId,
      handle,
      imageAlt,
      imageSrc,
      productBadge,
      productDimensions,
      productCardVariantImages,
      productSubtitle,
      productTitle,
      comparePanelAssetSrc,
      comparePanelAssetAlt,
      comparePanelPrice,
      productItemData: $productItemData,
    };

    if (productId && currentItems?.length > 0) {
      const hasDuplicate = checkForDuplicateAndRemove(productId);

      if (hasDuplicate) return;
    }

    const comparePanelSessionStorage = JSON.parse(sessionStorage.getItem('comparePanelStorage'));
    const comparePanelSize = comparePanelSessionStorage
      ? comparePanelSessionStorage.length
      : 0;

    if (!comparePanelSessionStorage || comparePanelSessionStorage.length === 0) {
      sessionStorage.setItem('comparePanelStorage', JSON.stringify([comparePanelStorage]));
      sessionStorage.setItem('comparePanelLocation', JSON.stringify(location));
      addToShortlist(c, comparePanelStorage, $emptyShortlistItem);
    } else if (comparePanelSize < 4) {
      const storedShortlistItems = JSON.parse(sessionStorage.getItem('comparePanelStorage'));
      storedShortlistItems.push(comparePanelStorage);
      sessionStorage.setItem('comparePanelStorage', JSON.stringify(storedShortlistItems));
      SDG.Data.shortlistItems = storedShortlistItems;
      addToShortlist(c, comparePanelStorage, $emptyShortlistItem);
    }

    __.removeClass($comparePanelTab, c.cls.hide);

    if (!__.hasClass($comparePanelTab, c.cls.active)) {
      $comparePanelTab.click();
      toggleTabText($comparePanel);
    }

    setTimeout(() => {
      $comparePanelToggle.focus();
    }, 10);
  }

  /**
   * Handle Remove From Shortlist Click
   * @param {Object} e - click event
   */
  function handleRemoveFromShortlistClick(e) {
    const $shortlistItemsList = document.querySelector(`.${c.dom.shortlistItemsList}`);
    const target = e?.target || e;

    const $shortlistItemParent = __.parents(target);
    const $shortlistItem = $shortlistItemParent
      ? $shortlistItemParent.find(($parent) => $parent.classList.contains(c.dom.shortlistItem))
      : null;
    const shortlistItemId = parseInt($shortlistItem.id, 10);
    const shortlistItemProductId = parseInt($shortlistItem.dataset.productId, 10);
    const $productItemApp = document.querySelector(`.${c.dom.productItemApp}[data-product-id="${shortlistItemProductId}"]`);

    if ($shortlistItem.classList.contains(c.cls.empty)) return;

    if ($productItemApp) {
      const $heartBtnParent = $productItemApp.querySelector(`.${c.dom.addToShortlistBtn}`).parentNode;
      __.removeClass($heartBtnParent, c.cls.isSelected);
    }

    const comparePanelSessionStorage = JSON.parse(sessionStorage.getItem('comparePanelStorage'));
    /* eslint-disable-next-line */
    const updatedComparePanelStorage = comparePanelSessionStorage.filter((item) => item.id !== shortlistItemId);
    sessionStorage.setItem('comparePanelStorage', JSON.stringify(updatedComparePanelStorage));
    removeFromComparePanel(shortlistItemId);
    appendEmptyToComparePanel($shortlistItemsList);
    addEvents();
  }

  /**
   * Handle Toggle
   * @param {Object} e - click event
   */
  function handleTabToggle(e) {
    const target = e.target || this;
    const $tabParents = __.parents(target);
    const $tab = $tabParents
      ? $tabParents.find(($parent) => $parent.classList.contains(c.dom.comparePanelTab))
      : null;

    if (!$tab) return;

    toggleTabText($tab);
  }

  /**
   * Handle Navigation
   */
  function handleNavigation() {
    window.location.href = '/pages/shortlist';
  }

  /**
   * Remove From Compare Panel
   * @param {Number} id
   */
  function removeFromComparePanel(id) {
    const numStoredItems = JSON.parse(sessionStorage.getItem('comparePanelStorage')).length;
    const numRemainingItems = 4 - numStoredItems;
    const $el = document.getElementById(id);
    $el.remove();

    // Compare Button
    const $compareBtn = $comparePanel.querySelector(`.${c.dom.compareBtn}`);

    // Remaining
    const $emptyShortlistRemaining = $comparePanel.querySelectorAll(`.${c.dom.shortlistRemaining}`);

    if (numRemainingItems === 4) {
      $emptyShortlistRemaining.forEach(($item) => {
        $item.innerText = '2 more';
      });
      $compareBtn.setAttribute('disabled', true);
    } else if (numRemainingItems === 3) {
      $emptyShortlistRemaining.forEach(($item) => {
        $item.innerText = 'one more';
      });
      $compareBtn.setAttribute('disabled', true);
    } else {
      $emptyShortlistRemaining.forEach(($item) => {
        $item.innerText = `up to ${numRemainingItems} more frames`;
      });
      $compareBtn.removeAttribute('disabled');
    }
  }

  /**
   * Append Empty To Compare Panel
   * @param {HTMLElement} $el
   */
  function appendEmptyToComparePanel($el) {
    if (!$el) return;

    // Shortlist Item
    const $emptyShortlistItem = document.createElement('button');
    $emptyShortlistItem.classList.add('compare-panel__shortlist-item', 'js-shortlist-item', 'empty');
    $emptyShortlistItem.setAttribute('data-ol-has-click-handler', '');
    $emptyShortlistItem.innerHTML = `
      <div class="compare-panel__shortlist-item-btn">
        <div class="compare-panel__shortlist-item-media js-shortlist-item-media">
          <div class="ir ir--swatch compare-panel__shortlist-item-image-wrapper">
            <img class="compare-panel__shortlist-item-image js-shortlist-item-image lazyautosizes lazyloaded" data-widths="[102]" data-sizes="auto" tabindex="-1" alt="Add shortlist item" data-srcset="//staging.framebridge.dev/cdn/shop/files/add-shortlist-item_102x.png?v=1689276755 102w" sizes="124px" srcset="//staging.framebridge.dev/cdn/shop/files/add-shortlist-item_102x.png?v=1689276755 102w">
          </div>
          <script>
            function preventDrag(e) {
              e.preventDefault();
            }
          </script>
        </div>
        <div class="compare-panel__shortlist-item-details js-shortlist-item-details">
          <p class="compare-panel__shortlist-item-title js-shortlist-item-title">
            No Frame
          </p>
          <p class="compare-panel__shortlist-item-price js-shortlist-item-price"></p>
        </div>
      </button>
    `;

    $el.append($emptyShortlistItem);
  }

  /**
   * Toggle Tab Text
   * @param {HTMLElement} $el
   */
  function toggleTabText($el) {
    const $button = $el.querySelector(`.${c.dom.comparePanelToggle}`);
    const $expandText = $button.querySelector('.compare-panel__tab-text--expand');
    const $minimizeText = $button.querySelector('.compare-panel__tab-text--minimize');
    if ($el.classList.contains(c.cls.active)) {
      __.removeClass($expandText, c.cls.hide);
      __.addClass($minimizeText, c.cls.hide);
    } else {
      __.removeClass($minimizeText, c.cls.hide);
      __.addClass($expandText, c.cls.hide);
    }
  }

  return init();
}

/**
 * Add Items to Shortlist
 */
export function addToShortlist(opts, shortlistItem, $emptyShortlistItem) {
  const $comparePanel = document.getElementById(opts.dom.comparePanel);
  const numStoredItems = JSON.parse(sessionStorage.getItem('comparePanelStorage')).length;
  const numRemainingItems = 4 - numStoredItems;
  const $productItemApp = document.querySelector(`.${opts.dom.productItemApp}[data-product-id="${shortlistItem.productId}"]`);
  const $shortListBtn = $productItemApp
    ? $productItemApp.querySelector(`.${opts.dom.addToShortlistBtn}`)
    : null;
  const $shortListBtnParent = $shortListBtn
    ? $shortListBtn.parentNode
    : null;

  if (!$emptyShortlistItem) return;

  const $emptyShortlistItemDetails = $emptyShortlistItem.querySelector(`.${opts.dom.shortlistItemDetails}`);
  __.addClass($emptyShortlistItemDetails, opts.cls.added);
  const $emptyShortlistItemPrice = $emptyShortlistItemDetails
    ? $emptyShortlistItemDetails.querySelector(`.${opts.dom.shortlistItemPrice}`)
    : null;
  const $emptyShortlistItemTitle = $emptyShortlistItemDetails
    ? $emptyShortlistItemDetails.querySelector(`.${opts.dom.shortlistItemTitle}`)
    : null;

  // Media
  const $emptyShortlistItemMedia = $emptyShortlistItem.querySelector(`.${opts.dom.shortlistItemMedia}`);
  const $emptyShortlistItemImage = $emptyShortlistItemMedia
    ? $emptyShortlistItemMedia.querySelector(`.${opts.dom.shortlistItemImage}`)
    : null;
  const { widths } = $emptyShortlistItemImage.dataset;
  const imageWidth = `${widths.replace('[', '').replace(']', '')}`;
  const image = __.getSizedImageUrl(shortlistItem.comparePanelAssetSrc, `${imageWidth}x`).replace('_small', '');
  $emptyShortlistItemImage.src = `${image} ${imageWidth}w`;
  $emptyShortlistItemImage.srcset = `${image} ${imageWidth}w`;
  $emptyShortlistItemImage.setAttribute('data-src', `${image} ${imageWidth}w`);
  $emptyShortlistItemImage.setAttribute('data-srcset', `${image} ${imageWidth}w`);
  $emptyShortlistItemImage.alt = shortlistItem.comparePanelAssetAlt;

  // Details
  $emptyShortlistItemTitle.innerText = shortlistItem.productTitle;
  $emptyShortlistItemPrice.innerText = shortlistItem.comparePanelPrice;

  // Compare Button
  const $compareBtn = $comparePanel.querySelector(`.${opts.dom.compareBtn}`);

  // Remaining
  const $emptyShortlistRemaining = $comparePanel.querySelectorAll(`.${opts.dom.shortlistRemaining}`);

  if (numRemainingItems === 4) {
    $emptyShortlistRemaining.forEach(($item) => {
      $item.innerText = '2 more';
    });
    $compareBtn.setAttribute('disabled', true);
  } else if (numRemainingItems === 3) {
    $emptyShortlistRemaining.forEach(($item) => {
      $item.innerText = 'one more';
    });
    $compareBtn.setAttribute('disabled', true);
  } else {
    $emptyShortlistRemaining.forEach(($item) => {
      $item.innerText = `up to ${numRemainingItems} more frames`;
    });
    $compareBtn.removeAttribute('disabled');
  }

  $emptyShortlistItem.id = shortlistItem.id;
  $emptyShortlistItem.setAttribute('data-product-id', shortlistItem.productId);
  if ($shortListBtnParent) __.addClass($shortListBtnParent, opts.cls.isSelected);

  __.removeClass($emptyShortlistItem, opts.cls.empty);
}
